// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1rPM9","header":"ReportDetails_header__3Q-pJ","title":"ReportDetails_title__1_4Z8","left":"ReportDetails_left__YdNar"};